import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FAQS } from "@/lib/brand";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

export default function FAQ() {
  return (
    <div className="bg-navy min-h-screen text-white">
      <Navbar />
      <section className="pt-32 pb-10 text-center grain">
        <HelpCircle className="w-12 h-12 text-turquoise mx-auto mb-3" />
        <h1 className="font-display font-black text-4xl sm:text-5xl">FREQUENTLY ASKED</h1>
        <p className="text-white/60 mt-3">Everything parents need to know about Adventure Rock.</p>
      </section>
      <section className="max-w-3xl mx-auto px-4 pb-24">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map(([q, a], i) => (
            <AccordionItem key={q} value={`item-${i}`} className="glass border border-white/10 rounded-2xl px-5" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display font-semibold text-left text-white hover:text-turquoise hover:no-underline">{q}</AccordionTrigger>
              <AccordionContent className="text-white/70">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>
      <Footer />
    </div>
  );
}
